import React from 'react';
import moment from 'moment-timezone';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CustTableColumns = (customerSendResetEmail, houseID) => {
  const hidePwLinkArray = [965];
  const showPasswordColumn = hidePwLinkArray.indexOf(houseID) === -1;

  const tableColumns = [
    {
      Header: (<div>First Name <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'firstname',
      className: 'wrap-table-cell',
      minWidth: 160,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (a.firstname.length) ? a.firstname.toLowerCase() : '';
        const bValue = (b.firstname.length) ? b.firstname.toLowerCase() : '';
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { firstname } }) => {
        if (!firstname) {
          return null;
        }

        return <span>{firstname}</span>;
      }
    },
    {
      Header: (<div>Last Name <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'lastname',
      className: 'wrap-table-cell',
      minWidth: 160,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (a.lastname.length) ? a.lastname.toLowerCase() : '';
        const bValue = (b.lastname.length) ? b.lastname.toLowerCase() : '';
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { lastname } }) => {
        if (!lastname) {
          return null;
        }

        return <span>{lastname}</span>;
      }
    },
    {
      Header: 'Address',
      headerClassName: 'd-flex align-items-center',
      id: 'address',
      className: 'wrap-table-cell',
      minWidth: 180,
      sortable: false,
      accessor: d => d,
      Cell: ({ value: { address, address2, city, state, postcode, country } }) => {
        if (!address) {
          return null;
        }

        return (
          <div>
            <div>{address}</div>
            <div>{address2}</div>
            <div>
              {city}
              {city ? `, ${state}` : state}
              {postcode ? ` ${postcode}` : ''}
              {country ? ` ${country}` : ''}
            </div>
          </div>
        );
      }
    },
    {
      Header: 'Email',
      headerClassName: 'd-flex align-items-center',
      id: 'email',
      className: 'wrap-table-cell',
      minWidth: 200,
      sortable: false,
      accessor: d => d,
      Cell: ({ value: { email } }) => {
        if (!email) {
          return null;
        }

        return <span>{email}</span>;
      }
    },
    {
      Header: 'Phone',
      headerClassName: 'd-flex align-items-center',
      id: 'phone',
      className: 'wrap-table-cell',
      minWidth: 100,
      sortable: false,
      accessor: d => d,
      Cell: ({ value: { phone } }) => {
        if (!phone) {
          return null;
        }

        return <span>{phone}</span>;
      }
    },
    {
      Header: (<div>Account Created <FontAwesomeIcon className="ml-1 not-small" icon="sort" /></div>),
      headerClassName: 'd-flex align-items-center',
      id: 'accountCreated',
      className: 'wrap-table-cell',
      minWidth: 150,
      sortable: true,
      accessor: d => d,
      sortMethod: (a, b) => {
        const aValue = (a.accountCreated.length) ? moment(a.accountCreated).format('YYYYMMDD') : '';
        const bValue = (b.accountCreated.length) ? moment(b.accountCreated).format('YYYYMMDD') : '';
        if (aValue === bValue) return 0;
        return (aValue > bValue) ? 1 : -1;
      },
      Cell: ({ value: { accountCreated } }) => {
        if (!accountCreated) {
          return null;
        }

        return <span>{accountCreated}</span>;
      }
    }
  ];

  const passwordColumn = {
    Header: 'Reset Password',
    headerClassName: 'd-flex align-items-center',
    id: 'forgot',
    className: 'wrap-table-cell text-center',
    minWidth: 110,
    sortable: false,
    accessor: d => d,
    Cell: ({ value: { email } }) => {
      if (!email) {
        return null;
      }

      return (
        <Button
          color="link"
          aria-label="Send email"
          title="Send email"
          onClick={() => customerSendResetEmail(email)}
        >
          <span className="small">Reset Password</span>
        </Button>
      );
    }
  };
 
  if (showPasswordColumn) {
    tableColumns.push(passwordColumn)
  }

  return tableColumns;
};

export default CustTableColumns;
